/**
 * Wildpeak Theme - Product Card Scroll Animation
 * Bottom-to-top reveal using IntersectionObserver (BAPE style)
 *
 * HOW TO ADD TO THEME:
 * 1. Upload this file to Assets in Shopify Theme Editor
 * 2. In theme.liquid (or base.liquid), add before </body>:
 *    {{ 'product-card-animate.js' | asset_url | script_tag }}
 * 3. In theme.liquid <head>, add:
 *    {{ 'product-card-animate.css' | asset_url | stylesheet_tag }}
 */
/*
(function () {
  'use strict';

  // Run after DOM is ready
  function init() {
    setupObserver();
    watchForNewCards(); // Handles "Show more" / infinite scroll new cards
  }

  /**
   * Main IntersectionObserver setup
   */
 /* function setupObserver() {
    var cards = document.querySelectorAll('.f-column.card');

    if (!cards.length) return;

    // Check if browser supports IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show all cards immediately
      cards.forEach(function (card) {
        card.classList.add('is-loaded');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var card = entry.target;
            card.classList.add('is-visible');
            // Stop observing once animated - no need to re-trigger
            observer.unobserve(card);
          }
        });
      },
      {
        threshold: 0.08,       // Trigger when 8% of card is visible
        rootMargin: '0px 0px -40px 0px' // Slight offset from bottom of viewport
      }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });

    // Store observer on window so MutationObserver can reuse it
    window._wpCardObserver = observer;
  }

  /**
   * Watch for new cards added by "Show more" button / infinite scroll
   * Wildpeak uses grid-list with dynamically appended .f-column.card elements
   */
 /* function watchForNewCards() {
    var grid = document.querySelector('#ProductsList, .products-list, grid-list');

    if (!grid) return;

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          // Only process element nodes that are product cards
          if (node.nodeType !== 1) return;

          var newCards = [];

          // The added node itself might be a card
          if (node.classList && node.classList.contains('f-column') && node.classList.contains('card')) {
            newCards.push(node);
          }

          // Or it might contain cards (e.g. a wrapper div)
          var nested = node.querySelectorAll ? node.querySelectorAll('.f-column.card') : [];
          nested.forEach(function (c) { newCards.push(c); });

          // Animate new cards with staggered delay
          newCards.forEach(function (card, index) {
            // Reset state so animation plays fresh
            card.classList.remove('is-visible', 'is-loaded');

            // Small delay per card for wave effect
            var delay = index * 70; // 70ms between each card

            setTimeout(function () {
              card.classList.add('animate-in');
              // Also mark as visible so CSS knows it's done
              setTimeout(function () {
                card.classList.remove('animate-in');
                card.classList.add('is-visible');
              }, 600); // Match animation duration
            }, delay);
          });
        });
      });
    });

    mutationObserver.observe(grid, {
      childList: true,
      subtree: true
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
*/
(function () {
  'use strict';

  var observer;

  function setupObserver() {
    var cards = document.querySelectorAll('.f-column.card:not(.is-visible)');
    if (!cards.length) return;

    var visibleIndex = 0;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var card = entry.target;
          var delay = visibleIndex * 100;
          visibleIndex++;

          card.style.opacity = '0';
          card.style.transform = 'translateY(60px)';
          card.style.transition = 'none';

          setTimeout(function () {
            card.style.transition = 'opacity 0.55s cubic-bezier(0.22,1,0.36,1), transform 0.55s cubic-bezier(0.22,1,0.36,1)';
            card.style.transitionDelay = '0s';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
            card.classList.add('is-visible');
          }, delay);

          observer.unobserve(card);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function handleNewCards(cards) {
    cards.forEach(function (card, index) {
      card.classList.remove('is-visible');
      card.style.opacity = '0';
      card.style.transform = 'translateY(60px)';
      card.style.transition = 'none';
      card.style.transitionDelay = '0s';

      setTimeout(function () {
        card.style.transition = 'opacity 0.55s cubic-bezier(0.22,1,0.36,1), transform 0.55s cubic-bezier(0.22,1,0.36,1)';
        card.style.transitionDelay = (index * 0.1) + 's';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
        card.classList.add('is-visible');
      }, 100 + (index * 100));
    });
  }

  function watchForNewCards() {
    var grid = document.querySelector('#ProductsList, .products-list, grid-list');
    if (!grid) return;

    new MutationObserver(function (mutations) {
      var newCards = [];

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.classList && node.classList.contains('f-column') && node.classList.contains('card')) {
            newCards.push(node);
          }

          var nested = node.querySelectorAll ? node.querySelectorAll('.f-column.card') : [];
          nested.forEach(function (c) { newCards.push(c); });
        });
      });

      if (newCards.length) {
        handleNewCards(newCards);
      }
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    setupObserver();
    watchForNewCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();